import { render, staticRenderFns } from "./AddLog.vue?vue&type=template&id=38fc8d76&scoped=true&"
import script from "./AddLog.vue?vue&type=script&lang=js&"
export * from "./AddLog.vue?vue&type=script&lang=js&"
import style0 from "./AddLog.vue?vue&type=style&index=0&id=38fc8d76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38fc8d76",
  null
  
)

export default component.exports